// extracted by mini-css-extract-plugin
module.exports =  {"errorLink":"errorLink_V6JlZyRr","errorColour":"errorColour_kCMWy7UE"};